// Actions
export const NAVIGATION_CLICKED = "NAVIGATION_CLICKED";

export interface NavigationClickAction {
    type: typeof NAVIGATION_CLICKED;
}

export function navigationClicked(): NavigationClickAction {
    return {
        type: NAVIGATION_CLICKED,
    };
}
